import { LEDGER_DETAIL, LEDGER_DETAIL_FILTER, LEDGER_DETAIL_SORT, LEDGER_DETAIL_SORT_CLEAR, } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initLedgerDetails = {
    detail: [],
    filterData: {
        simpleFilter: {
            name: "Voucher",
            filters: [],
        },
        assetFilter: {
            name: "Exchange",
            filters: [],
        },
    },
    sortData: {
        sortState: [],
        sortRecord: {},
        data: [],
    },
};
const LedgerDetailReducer = (state = initLedgerDetails, action) => {
    switch (action.type) {
        case LEDGER_DETAIL:
            return Object.assign(Object.assign({}, state), { detail: action.payload.detail });
        case LEDGER_DETAIL_SORT:
            return Object.assign(Object.assign({}, state), { sortData: action.payload.sortData });
        case LEDGER_DETAIL_FILTER:
            return Object.assign(Object.assign({}, state), { filterData: action.payload.filterData });
        case LEDGER_DETAIL_SORT_CLEAR:
            return Object.assign(Object.assign({}, state), { sortData: initLedgerDetails.sortData });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: LedgerDetailReducer,
    commonData: commonOnePlatFormReducer,
});
